import { useEffect } from "react"

const useScrollAnimation = () => {
  const addScrollToElements = (scrollType) => {
    const elements = document.querySelectorAll(`[data-aos-${scrollType}]`)
    elements.forEach((element) => {
      if (!element.className.includes(`aos-${scrollType}`)) {
        element.className += ` aos-${scrollType}`
      }
      if (element.dataset.aosDelay) {
        console.log(element.dataset.aosDelay)
        element.style.transitionDelay = element.dataset.aosDelay + "ms"
      }
    })
    return elements
  }

  useEffect(() => {
    const elements = addScrollToElements("fade")
    // Events to be able to remove listeners
    const scrollEvent = () => onScroll(elements)
    const resizeEvent = () => {
      onScroll(elements)
      window.removeEventListener("scroll", scrollEvent)
      window.addEventListener("scroll", scrollEvent)
    }
    // Fires on every scroll
    const onScroll = (elements) => {
      const html = document.documentElement
      let lastKnownScrollPosition = window.scrollY + html.clientHeight
      let offset = 200

      elements.length &&
        elements.forEach((element) => {
          if (
            element.offsetTop < lastKnownScrollPosition - offset &&
            !element.className.includes("aos-active")
          ) {
            element.className += " aos-active"
          }
        })
    }
    if (window) {
      window.addEventListener("resize", resizeEvent)
      window.addEventListener("scroll", scrollEvent)
    }
    return () => {
      window.removeEventListener("resize", resizeEvent)
      window.removeEventListener("scroll", scrollEvent)
    }
  }, [])
}

export default useScrollAnimation
